<template>
  <v-dialog :value="value" :max-width="width" :persistent="busy" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" :content-class="'pos-dialog' + (dark ? ' pos-dialog--dark' : '')" @input="$emit('input', $event)">
    <v-card v-if="value" :dark="dark" :light="!dark" class="pos-dialog__card">
      <v-card-title class="pos-dialog__header"><span v-if="icon" class="pos-dialog__icon"><v-icon size="22">{{ icon }}</v-icon></span><div class="pos-dialog__title"><h2>{{ title }}</h2><p v-if="subtitle">{{ subtitle }}</p></div><v-spacer /><v-btn icon :disabled="busy" aria-label="Dialog schliessen" title="Schliessen" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
      <v-card-text class="pos-dialog__body" :class="bodyClass"><slot /></v-card-text>
      <v-card-actions v-if="$slots.actions" class="pos-dialog__actions"><slot name="actions" /></v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import "./posWorkspace.css"
export default {
  inject: { posTheme: { default: () => () => false } },
  props: { value: Boolean, busy: Boolean, title: String, subtitle: String, icon: String, bodyClass: String, width: { type: [String, Number], default: 600 } },
  computed: { dark() { return this.posTheme() } },
}
</script>
